import { render } from "./AdicionarResponsavel.vue?vue&type=template&id=c2eebf4e&scoped=true"
import script from "./AdicionarResponsavel.vue?vue&type=script&lang=js"
export * from "./AdicionarResponsavel.vue?vue&type=script&lang=js"

import "./AdicionarResponsavel.vue?vue&type=style&index=0&id=c2eebf4e&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2eebf4e"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QForm,QSelect,QCheckbox,QField});
